import React from 'react';

import closeButton from 'assets/icons/close-button.svg';

import './styles.css';

interface Props {
  text: string;
  removeRooms: (Array) => void;
  enableRoomRemove: boolean;
  rooms: any;
}

class SelectedRoomReview extends React.Component<Props> {
  render() {
    const {text, removeRooms, enableRoomRemove, rooms} = this.props;
    return (
      <div className="SelectedRoomReview">
        <span>{text}</span>
        <span
          className="colab-centered removeButton"
          onClick={() => removeRooms(rooms)}>
          {enableRoomRemove && <img src={closeButton} alt="Remove item" />}
        </span>
      </div>
    );
  }
}

export default SelectedRoomReview;
